<script setup>
// Presentazionale: stato/persistenza in usePrivacyNotice. Montato solo fuori
// da /admin. Informativa minimale senza scelte (nessun cookie da accettare o
// rifiutare): un solo pulsante di chiusura.
//
// Card a layout manuale (niente classi `alert` di DaisyUI): in DaisyUI 5
// `.alert` è un grid a colonne icona/contenuto/azioni, quindi le utility
// flex-col/items-* non hanno alcun effetto su di essa e il bottone resta
// incollato in alto invece di andare sotto al testo.
import { ShieldCheck } from 'lucide-vue-next'

defineProps({
  // Come PwaPublicHost: resta nascosto finché l'intro della Home non ha
  // finito il suo effetto, poi compare in dissolvenza con il resto della UI.
  introHidden: { type: Boolean, default: false }
})
defineEmits(['dismiss'])
</script>

<template>
  <!-- bottom offset: sopra la bottom-nav fixed della Home (~3.5rem + safe-area),
       stesso slot di PwaPublicHost — mai sopra il titolo/header. -->
  <div
    role="region"
    aria-label="Informativa privacy"
    class="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom,0px)+4.25rem)] z-40 flex justify-center px-4 transition-opacity duration-500"
    :class="introHidden ? 'opacity-0' : 'opacity-100'"
  >
    <div
      class="w-full max-w-sm rounded-xl border border-base-300 bg-base-100 p-4 shadow-lg"
      :class="introHidden ? 'pointer-events-none' : 'pointer-events-auto'"
    >
      <div class="flex items-center gap-2">
        <ShieldCheck class="size-5 shrink-0 text-primary" aria-hidden="true" />
        <span class="text-sm font-semibold text-base-content">Privacy</span>
      </div>
      <p class="mt-2 text-sm text-base-content/70">
        Nessun cookie di tracciamento: solo un identificativo anonimo sul dispositivo per contare gli utenti connessi.
      </p>
      <button
        type="button"
        data-test="dismiss-privacy-notice"
        class="btn btn-primary btn-sm btn-block mt-3 rounded-xl"
        aria-label="Chiudi informativa privacy"
        @click="$emit('dismiss')"
      >
        Ho capito
      </button>
    </div>
  </div>
</template>
